import {inheritPrototype, isDef} from '../util/util'
import Base from './base'
// 饼图的配置
var PieShare = function (dataList, type) {
  Base.call(this)
  this.type = type
  if (dataList) {
    this.xList = isDef(dataList.xList) ? dataList.xList : []
    this.yList = isDef(dataList.yList) ? dataList.yList : []
    this.optionSet = isDef(dataList.optionSet) ? dataList.optionSet : {}
  } else {
    this.xList = []
    this.yList = []
    this.optionSet = {}
  }

  this.init()
}
inheritPrototype(PieShare, Base)
PieShare.prototype.init = function () {
  this.option.title = this.getTitle()
  this.option.grid = this.getGrid()
  let isShowTooltip=isDef(this.optionSet.isShowTooltip)?this.optionSet.isShowTooltip:'true'
  if(isShowTooltip){
    this.option.tooltip = this.getTooltip()
  }
  this.option.series = this.getSeries()
  let legend = []
  if (this.option.series && this.option.series.length > 0) {
    let data = this.option.series[0].data
    if (data && data.length > 0) {
      for (let item of data) {
        legend.push({
          name: item.name
        })
      }
    }
  }
  this.option.legend = this.getLegend(legend)
}
PieShare.prototype.getTitle = function () {
  let isShowLegend = isDef(this.optionSet.isShowLegend) ? this.optionSet.isShowLegend : true
  let pieTitleShow = this.optionSet.pieTitleShow
  let text = this.optionSet.text
  let subText = this.optionSet.subText
  let y = '50%'
  if(isShowLegend){
    y = '33%'
  }else{
    y = '40%'
  }

  let title = {
    show: isDef(pieTitleShow) ? pieTitleShow : true,
    text: isDef(text) ? text : '',
    subtext: isDef(subText) ? subText : '',
    textStyle: {
      fontSize: 22,
      align: 'center',
      color: '#575B60'
    },
    subtextStyle: {
      fontSize: 14,
      color: '#676B71'
    },
    x: 'center',
    y: y
  }
  return title
}
PieShare.prototype.getSeries = function () {
  //let isShowLegend = isDef(this.optionSet.isShowLegend) ? this.optionSet.isShowLegend : true
  let unit=isDef(this.optionSet.unit)?this.optionSet.unit:'';
  let series = []
  if (this.yList && this.yList.length > 0) {
      //let pieRadiusFull = isDef(this.optionSet.pieRadiusFull) ? this.optionSet.pieRadiusFull : false
      //let pieRoseType = isDef(this.optionSet.pieRoseType) ? this.optionSet.pieRoseType : false
      let pieLabel = isDef(this.optionSet.pieLabel) ? this.optionSet.pieLabel : false
      let isShowEmphasis = isDef(this.optionSet.isShowEmphasis) ? this.optionSet.isShowEmphasis : false
      let labelPosition=isDef(this.optionSet.labelPosition) ? this.optionSet.labelPosition : 'center'
      for(let item of this.yList){
          let color = isDef(item.color) ? item.color : [];
          let outerRadius= isDef(item.outerRadius) ? item.outerRadius : ['60%','80%'];
          let posionItemStyle=isDef(item.posionItemStyle) ? item.posionItemStyle :'outer';
          series.push({
              name: item.name,
              type: 'pie',
              center:  ['50%', '50%'],
              radius: outerRadius,
              selectedMode: 'single',
              selectedOffset:1,
              color: color,
              minAngle: 20,//最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
              avoidLabelOverlap: true,   //是否启用防止标签重叠策略
              data: item.data,
              itemStyle: posionItemStyle === 'outer' ? {
                  normal: {
                      // 设置扇形的阴影
                      shadowBlur: 10,
                      shadowColor: 'rgba(0,173,223,0.3)',
                      shadowOffsetX: 0,
                      shadowOffsetY: 10,
                      borderWidth: 2,
                      borderColor: '#0A1123'
                  }
              } : {},
              labelLine:{
                  normal:{
                      length:3
                  }
              },
              label: {
                  normal: {
                      show: pieLabel,
                      textStyle: {
                          fontSize: 12
                      },
                      position: labelPosition,
                      formatter: function (param) {
                          return param.name + ':\n' + param.value + unit + ' ' + param.percent + '%'
                      }
                  },
                  emphasis: {
                      show: isShowEmphasis,
                      formatter: [
                          '{bt|{d}}{nt|%}',
                          '{num|{b}}'
                      ].join('\n'),
                      rich: {
                          bt: {
                              fontSize: '30',
                              color:'#fff',
                              fontWeight:'600',
                          },
                          nt: {
                              fontSize: '18',
                              color:'#fff',
                              fontWeight:'600',
                          },
                          num:{
                              fontSize: '18',
                              color:'#95AFCA',
                              fontWeight:'400',
                          }
                      },
                  }
              }
          })
      }
    return series
  }
}



export default PieShare
